module.exports = __webpack_public_path__ + "img/logo-and-year.4525867a.svg";